import React, { useEffect, useState, useRef } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";

import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchData,
  addItemApk,
} from "./settingSlice";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { checkEmptyFields, showDialog, showErrorDialog, showSuccessDialog } from "../../utility";
import { SettingTable } from "./SettingTable";

export const ApkPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const ref = useRef();

  // Filter
  const [name, setName] = useState("");
  const [fileLogo, setFileLogo] = useState(null);

  useEffect(() => {
    async function fetchMyAPI() {}
    fetchMyAPI();
  }, [dispatch]);

  const handleSave = async () => {
    const fields = [{ value: name, message: "input Version", valid: true }];

    const errorMessage = checkEmptyFields(fields);
    if (errorMessage) {
      return showDialog(errorMessage);
    }

    if (fileLogo === null) {
      return showDialog("Please input File");
    }
    const payload = name

    const file = fileLogo;

    console.log(payload, file, "payloasd");

    try {
      const response = await dispatch(addItemApk({ payload, file }));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        await window.location.reload();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="Apk Upload"></CardHeader>{" "}
      <CardBody>
        {/* Filter */}
        <Form className="mb-5">
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Version</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </Col>
              </Form.Group>
            </Col>

            {/* Right Row */}

            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>File</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    ref={ref}
                    type="file"
                    label="Input File Name"
                    onChange={(e) => setFileLogo(e.target.files[0])}
                    custom
                    accept=".apk"
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col sm={3}>
                  <Button
                    className="btn btn-outline-danger"
                    onClick={handleSave}
                  >
                    Save
                  </Button>
                </Col>
              </Form.Group>
            </Col>
          </Form.Group>
        </Form>
      </CardBody>
    </Card>
  );
};
